import { render, staticRenderFns } from "./PrimarySectionTitle.vue?vue&type=template&id=15aa6c92&scoped=true"
var script = {}
import style0 from "./PrimarySectionTitle.vue?vue&type=style&index=0&id=15aa6c92&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa6c92",
  null
  
)

export default component.exports